module.exports = __webpack_public_path__ + "img/SubArea.3bf0d3c0.png";